import { useEffect, useState } from "react";
import axios from "axios";
import { Eye, Users, Globe } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (n) => (typeof n === "number" ? n.toLocaleString("de-DE") : "–");

/**
 * Cards summarising vmbs.de page views (excludes admin/api routes).
 * Today + 7-day + lifetime; visits and unique IPs.
 */
export default function PageViewsCard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/stats/pageviews`, { withCredentials: true })
      .then(({ data }) => setStats(data))
      .catch(() => setStats({ total: 0, unique_ips: 0, today_total: 0, today_unique: 0, week_total: 0, week_unique: 0 }));
  }, []);

  const buckets = [
    {
      key: "today",
      label: "Heute",
      visits: stats?.today_total,
      unique: stats?.today_unique,
      Icon: Eye,
      accent: "text-[#C5993A]",
    },
    {
      key: "week",
      label: "Letzte 7 Tage",
      visits: stats?.week_total,
      unique: stats?.week_unique,
      Icon: Users,
      accent: "text-blue-400",
    },
    {
      key: "all",
      label: "Insgesamt",
      visits: stats?.total,
      unique: stats?.unique_ips,
      Icon: Globe,
      accent: "text-green-400",
    },
  ];

  return (
    <div
      data-testid="pageviews-card"
      className="mb-6 grid grid-cols-1 sm:grid-cols-3 gap-3"
    >
      {buckets.map((b) => {
        const Icon = b.Icon;
        return (
          <div
            key={b.key}
            data-testid={`pageviews-${b.key}`}
            className="bg-[#12202f] border border-[#3A4F60]/30 rounded-lg p-4 flex items-center gap-3"
          >
            <div className={`w-10 h-10 rounded-md bg-[#0C1620] border border-[#3A4F60]/40 flex items-center justify-center flex-shrink-0 ${b.accent}`}>
              <Icon className="w-5 h-5" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-[10px] uppercase tracking-wider text-[#3A4F60]">vmbs.de · {b.label}</div>
              <div className="flex items-baseline gap-2 mt-0.5">
                <span className="text-xl font-heading text-white tabular-nums" data-testid={`pageviews-${b.key}-visits`}>
                  {fmt(b.visits)}
                </span>
                <span className="text-[11px] text-[#8899AA]">Aufrufe</span>
              </div>
              <div className="text-[11px] text-[#8899AA] tabular-nums" data-testid={`pageviews-${b.key}-unique`}>
                {fmt(b.unique)} unique IPs
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
